import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { CKEditor } from "ckeditor4-react";

import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  CardHeader,
} from "reactstrap";

import { validateForm } from "utils/misc";

import {
  createProperty,
  loadProperty,
  cancelSave,
  setErrors,
  removeErrors,
} from "actions/admin/properties";
import Spinner from "views/components/Spinner";

import Errors from "views/components/Notifications/Errors";
import { useParams, useNavigate, Link } from "react-router-dom";
import LoadingButton from "views/components/LoadingButton";

import { FaTrash } from "react-icons/fa";
let images = [];
let imageUrls = [];
const AddProperty = ({
  createProperty,
  cancelSave,
  errorList,
  loadProperty,
  loading,
  setErrors,
  removeErrors,
}) => {
  const params = useParams();
  const history = useNavigate();
  const initialState = {
    title: "",
    description: "",
    price_full_unit: "",
    price_per_room: "",
    tour_link: "",
    property_image: [],
    property_image_url: [],
  };

  const [formData, setFormData] = useState(initialState);

  const onChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      case "property_image":
        const property_image_file = event.target.files;
        // const property_file_url = URL.createObjectURL(property_image_file);
        // images.push(property_image_file);
        // imageUrls.push(property_file_url);
        // setFormData({
        //   ...formData,
        //   property_image: images,
        //   property_image_url: imageUrls,
        // });
        for (let items of property_image_file) {
          const property_file_url = URL.createObjectURL(items);
          const propertyImageReader = new FileReader();
          propertyImageReader.onload = async () => {
            images.push(propertyImageReader.result);
            imageUrls.push(property_file_url);
            setFormData({
              ...formData,
              property_image: images,
              property_image_url: imageUrls,
            });
          };
          propertyImageReader.readAsDataURL(items);
        }
        break;
      case "title":
        setFormData({
          ...formData,
          [event.target.name]: value.replace(/[^a-z0-9 -]/gi, "") ? value.trimLeft()
            : value.trim(),
        });
        break;
      case "price_full_unit":
      case "price_per_room":
        setFormData({
          ...formData,
          [event.target.name]: value.replace(/[^0-9.]/gi, "") ? value.trimLeft()
            : value.trim(),
        });
        break;
      default:
        setFormData({
          ...formData,
          [event.target.name]: value.replace(/[^a-z0-9] /gi, "")
            ? value.trimLeft()
            : value.trim(),
        });
    }
  };

  const deleteImages = (index) => {
    images.splice(index, 1);
    imageUrls.splice(index, 1);
    setFormData({
      ...formData,
      property_image: images,
      property_image_url: imageUrls,
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    removeErrors();
    const validationParam = [
      {
        param: "title",
        msg: "Title is required.",
      },
      {
        param: "price_full_unit",
        msg: "Price is Required",
        type: "number",
      },
      {
        param: "price_per_room",
        msg: "Price is Required",
        type: "number",
      },
      {
        param: "property_image_url",
        msg: "Property Image Required",
      },
      {
        param: "description",
        msg: "Description is required.",
      },
    ];
    if (!validateForm(formData, validationParam, setErrors)) return;

    // const data = new FormData();
    // for (const key in formData) {
    //   if (key !== "property_image_url") {
    //     if (typeof formData[key] === "string") {
    //       data.append(key, formData[key]);
    //     } else {
    //       for (const id of formData.property_image) {
    //         data.append("property_image", id);
    //       }
    //     }
    //   }
    // }
    createProperty(formData, history);
    images = [];
    imageUrls = [];
  };

  const clearImageSelections = function () {
    images = [];
    imageUrls = [];
  };

  return (
    <div className="animated fadeIn">
      <Row>
        <Col xs="12">
          <Card>
            <CardHeader>
              <span className="pull-left h5">Add New Property</span>
            </CardHeader>
            <Form className="form-horizontal" onSubmit={(e) => onSubmit(e)}>
              <Card>
                <CardBody>
                  <Row>
                    <Col xs={6}>
                      <FormGroup>
                        <Label htmlFor="title">
                          Title <span>*</span>
                        </Label>
                        <Input
                          type="text"
                          id="title"
                          name="title"
                          value={formData.title}
                          maxLength="100"
                          required
                          onChange={(e) => onChange(e)}
                        // invalid={errorList.property_title ? true : false}
                        />
                        <Errors current_key="title" key="title" />
                      </FormGroup>
                    </Col>
                    <Col xs={6}>
                      <FormGroup>
                        <Label htmlFor="price_full_unit">
                          Price Full Unit - $ <span>*</span>
                        </Label>
                        <Input
                          type="text"
                          id="price_full_unit"
                          name="price_full_unit"
                          required
                          value={formData.price_full_unit}
                          onChange={(e) => onChange(e)}
                          invalid={errorList.price_full_unit ? true : false}
                        />
                        <Errors
                          current_key="price_full_unit"
                          key="price_full_unit"
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={6}>
                      <FormGroup>
                        <Label htmlFor="price_per_room">
                          Price Per Room - $ <span>*</span>
                        </Label>
                        <Input
                          type="text"
                          id="price_per_room"
                          name="price_per_room"
                          required
                          value={formData.price_per_room}
                          onChange={(e) => onChange(e)}
                          invalid={errorList.price_per_room ? true : false}
                        />
                        <Errors
                          current_key="price_per_room"
                          key="price_per_room"
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={6}>
                      <FormGroup>
                        <Label htmlFor="tour_link">
                          3D Tour Link <span>*</span>
                        </Label>
                        <Input
                          type="text"
                          id="tour_link"
                          name="tour_link"
                          value={formData.tour_link}
                          onChange={(e) => onChange(e)}
                        // invalid={errorList.tour_link ? true : false}
                        />
                        <Errors current_key="tour_link" key="tour_link" />
                      </FormGroup>
                    </Col>
                    <Col xs={12}>
                      <FormGroup>
                        <Label htmlFor="property_image">
                          Property Images <span>*</span>
                        </Label>
                        <Input
                          type="file"
                          id="property_image"
                          name="property_image"
                          multiple
                          required
                          onChange={(e) => onChange(e)}
                          accept="image/*"
                        // invalid={errorList.heading ? true : false}
                        />
                        <Errors
                          current_key="property_image"
                          key="property_image"
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12} className="previewImages">
                      {formData.property_image_url &&
                        formData.property_image_url.map((items, ind) => (
                          <div key={`image-${ind}`}>
                            <Button
                              type="button"
                              className=""
                              size="sm"
                              color="danger"
                              onClick={() => deleteImages(ind)}
                            >
                              <i className="fa fa-ban"></i> X
                            </Button>
                            <img
                              src={items}
                              className="preview-img img-fluid"
                              alt="image_file"
                            />
                          </div>
                        ))}
                    </Col>
                    <Col xs={12}>
                      <FormGroup>
                        <Label htmlFor="description">
                          Description <span>*</span>
                        </Label>
                        <Input
                          type="textarea"
                          id="description"
                          name="description"
                          required
                          value={formData.description}
                          onChange={(e) => onChange(e)}
                        // invalid={errorList.description ? true : false}
                        />
                        <Errors current_key="description" key="description" />
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <CardFooter>
                <>
                  <Button
                    type="submit"
                    className="m-1"
                    size="sm"
                    color="primary"
                    loading={loading}
                    disabled={loading}
                    style={{ width: "60px" }}
                  >
                    <i className="fa fa-dot-circle-o"></i>{" "}
                    {loading ? (
                      <Spinner style={{ fontSize: "20px" }} />
                    ) : (
                      <>Save</>
                    )}
                  </Button>
                  <Link to="/dashboard/properties">
                    <Button
                      type="reset"
                      className="m-1"
                      size="sm"
                      color="danger"
                      onClick={clearImageSelections}
                    >
                      <i className="fa fa-ban"></i> Cancel
                    </Button>
                  </Link>
                </>
              </CardFooter>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

AddProperty.propTypes = {
  loading: PropTypes.bool.isRequired,
  createProperty: PropTypes.func.isRequired,
  errorList: PropTypes.object.isRequired,
  cancelSave: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  errorList: state.errors,
  loading: state.properties.loadingProperty,
});
export default connect(mapStateToProps, {
  createProperty,
  cancelSave,
  loadProperty,
  setErrors,
  removeErrors,
})(AddProperty);
